import APIService from '@/services/api-service'
const resource = '/job'
const subResource = 'approval'

class ApprovalService extends APIService {
  public constructor () {
    super()
    this.mountAuthorizationToken()
  }

  public save (data: any) {
    return this.connector.put(`${resource}/${subResource}/save`, data)
  }
}

export default new ApprovalService()
